export function shortAddress(address: string, padding = 4) {
  return address.length ? `${address.slice(0, padding)}....${address.slice(padding * -1)}` : '';
}
